var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es387.js.map
